import { useEffect } from 'react';
import { getPageTitle } from '../utils/domainConfig';
import { clearFaviconUnreadBadge, setFaviconUnreadBadge } from '../utils/faviconBadge';

function syncAppIconBadge(count) {
  if (typeof navigator === 'undefined' || !('setAppBadge' in navigator)) return;

  const badgePromise =
    count > 0 ? navigator.setAppBadge(count) : navigator.clearAppBadge();

  if (badgePromise && typeof badgePromise.catch === 'function') {
    badgePromise.catch(() => {});
  }
}

export function useSmsUnreadBrowserAlerts(unreadCount) {
  useEffect(() => {
    return () => {
      if (typeof document === 'undefined') return;
      document.title = getPageTitle();
      clearFaviconUnreadBadge();
      syncAppIconBadge(0);
    };
  }, []);

  useEffect(() => {
    if (typeof document === 'undefined') return;

    const baseTitle = getPageTitle();
    const safeCount = Number.isFinite(unreadCount) && unreadCount > 0 ? unreadCount : 0;

    document.title = safeCount > 0 ? `(${safeCount}) ${baseTitle}` : baseTitle;
    setFaviconUnreadBadge(safeCount);
    syncAppIconBadge(safeCount);
  }, [unreadCount]);
}
